window.addEventListener('scroll', function () {
  const scroll = window.scrollY; // معادل $(window).scrollTop()
  const navbar = document.querySelector('.navbar');
  const scrollToTarget = document.querySelector('.scroll-to-target');
  const headerFixedHeight = document.getElementById('header-fixed-height');

  if (scroll < 245) {
    navbar?.classList.remove('sticky-menu');
    scrollToTarget?.classList.remove('open');
    headerFixedHeight?.classList.remove('active-height');
  } else {
    navbar?.classList.add('sticky-menu');
    scrollToTarget?.classList.add('open');
    headerFixedHeight?.classList.add('active-height');
  }
});

      // ✅ اسکرول نرم (معادل animate با duration: ~400-600ms)
document.addEventListener('DOMContentLoaded', () => {
  const scrollToElements = document.querySelectorAll('.scroll-to-target');

  scrollToElements.forEach(el => {
    el.addEventListener('click', function (e) {
      e.preventDefault();

      const targetSelector = this.getAttribute('data-target');
      if (!targetSelector) return;

      const targetElement = document.querySelector(targetSelector);
      if (!targetElement) return;

      const targetTop = targetElement.getBoundingClientRect().top + window.scrollY;

      window.scrollTo({
        top: targetTop,
        behavior: 'smooth' // ← این خط animate را فعال می‌کند
      });
    });
  });
});


document.addEventListener('DOMContentLoaded', function () {
  const wrapper = document.getElementById('edit-moderation-state-wrapper');
  if (!wrapper) return;

  // موقعیت و اندازه قبله‌عنصر را بر اساس CSS شما تعریف می‌کنیم:
  const pseudoHeight = 35; // line-height: 35px
  const pseudoWidth = 240;
  const pseudoTopOffset = -39; // top: -39px
  const pseudoLeftOffset = 0;  // left: 0

  wrapper.addEventListener('click', function (e) {
    const rect = wrapper.getBoundingClientRect();

    // مختصات ناحیه ::before نسبت به viewport
    const pseudoTop = rect.top + pseudoTopOffset;
    const pseudoLeft = rect.left + pseudoLeftOffset;
    const pseudoBottom = pseudoTop + pseudoHeight;
    const pseudoRight = pseudoLeft + pseudoWidth;

    // آیا کلیک داخل این مستطیل بوده؟
    const clickedOnPseudo = (
      e.clientX >= pseudoLeft &&
      e.clientX <= pseudoRight &&
      e.clientY >= pseudoTop &&
      e.clientY <= pseudoBottom
    );

    if (clickedOnPseudo) {
      e.stopPropagation();
      wrapper.classList.toggle('close');
    }
  });
});


(function (Drupal, once) {
  'use strict';

  /**
   * تبدیل عدد به حروف فارسی — فقط برای تومان (عدد ÷ 10)
   * @param {number|string} num — عدد ورودی (به ریال)
   * @returns {string} — مثلاً: «صد و پنجاه هزار تومان»
   */
  function numberToWordsTomann(num) {
    const n = Math.floor((parseInt(num, 10) || 0) / 10); // تبدیل ریال → تومان
    if (n === 0) return 'صفر تومان';

    const units = ['', 'یک', 'دو', 'سه', 'چهار', 'پنج', 'شش', 'هفت', 'هشت', 'نه',
      'ده', 'یازده', 'دوازده', 'سیزده', 'چهارده', 'پانزده', 'شانزده', 'هفده', 'هجده', 'نوزده'];
    const tens = ['', '', 'بیست', 'سی', 'چهل', 'پنجاه', 'شصت', 'هفتاد', 'هشتاد', 'نود'];
    const hundreds = ['', 'یکصد', 'دویست', 'سیصد', 'چهارصد', 'پانصد', 'ششصد', 'هفتصد', 'هشتصد', 'نهصد'];
    const scales = ['', 'هزار', 'میلیون', 'میلیارد'];

    function chunkToWords(x) {
      if (x === 0) return '';
      const parts = [];
      if (x >= 100) {
        parts.push(hundreds[Math.floor(x / 100)]);
        x %= 100;
      }
      if (x >= 20) {
        parts.push(tens[Math.floor(x / 10)]);
        x %= 10;
      }
      if (x > 0) parts.push(units[x]);
      return parts.join(' و ');
    }

    if (n < 20) return units[n] + ' تومان';

    const parts = [];
    let scale = 0, rem = n;
    while (rem > 0) {
      const part = rem % 1000;
      rem = Math.floor(rem / 1000);
      if (part !== 0) {
        let w = chunkToWords(part);
        if (scale > 0) w += ' ' + scales[scale];
        parts.unshift(w);
      }
      scale++;
    }

    return parts.join(' و ') + ' تومان';
  }

  Drupal.behaviors.ddiranPriceWords = {
    attach: function (context, settings) {
      once('ddiran-price-words', 'input[data-drupal-selector="edit-field-req-cost-0-value"]', context)
        .forEach(function (input) {
          // فقط روی type="number" اجرا شود
          if (input.type !== 'number') return;

          // پیدا کردن یا ایجاد <small> زیر فیلد
          const inputGroup = input.closest('.input-group');
          let small = inputGroup?.parentNode?.querySelector('.price-words');
          if (!small && inputGroup) {
            small = document.createElement('small');
            small.className = 'price-words text-muted';
            small.style.fontSize = '0.85em';
            small.style.display = 'block';
            small.style.marginTop = '0';
            small.style.marginBottom = '1rem';
            small.style.color = '#c73737ff';
            inputGroup.parentNode.insertBefore(small, inputGroup.nextSibling);
          }

          // تابع به‌روزرسانی حروف
          const updateWords = () => {
            const val = input.value.trim();
            small.textContent = val ? numberToWordsTomann(val) : '';
          };

          // به‌روزرسانی اولیه
          updateWords();

          // شنود تغییرات (کاربر تایپ می‌کند، backspace می‌زند، paste می‌کند و ...)
          input.addEventListener('input', updateWords);
          input.addEventListener('change', updateWords); // برای اطمینان بیشتر
        });
    }
  };

})(Drupal, once);

(function (Drupal, once) {

  Drupal.behaviors.frontVideo = {
    attach(context) {
console.log('frontVideo attach fired');
      once('front-video-modal', '#frontPresentVideo', context).forEach(function (modal) {

        modal.addEventListener('shown.bs.modal', function () {

          const video = modal.querySelector('video');

          if (!video) {
            return;
          }

          video.load();

          setTimeout(function () {
            video.play();
          }, 200);

        });

        modal.addEventListener('hidden.bs.modal', function () {

          const video = modal.querySelector('video');

          if (video) {
            video.pause();
            video.currentTime = 0;
          }

        });

      });

    }
  };

})(Drupal, window.once);